import React, { useEffect, useState } from 'react';
import styles from './AskYourDocs.module.scss';
import { ChatContainer } from 'app/components/Sections/AskYourDocs/Chat/ChatContainer/ChatContainer';
import { Sidebar } from 'app/components/Sections/AskYourDocs/Sidebar/Sidebar';
import {
  useAppDispatch,
  setSelectedDocuments,
  setCanSelectDocuments,
  useAppSelector,
  getCurrentFile,
  setCurrentFile
} from 'app/redux';
import { PDFHighlightPreview } from 'app/components';
import { Button } from '@zurich-primitives/button';
import { ReactComponent as CloseIcon } from 'app/assets/Icons/Close.svg';
import { AskYourDocsInstructions } from 'app/components/Modals';

export const AskYourDocsView: React.FC = () => {
  const [selectedChatId, setSelectedChatId] = useState<string | null>(null);
  const [selectedModel, setSelectedModel] = useState<'fast' | 'smart'>('fast');
  const [isNewChat, setIsNewChat] = useState<boolean>(false);
  const [refreshChatList, setRefreshChatList] = useState(0);
  const [isInstructionsOpen, setIsInstructionsOpen] = useState(false);
  const dispatch = useAppDispatch();
  const currentFile = useAppSelector(getCurrentFile);

  const handleSelectChat = (chatId: string | null): void => {
    setSelectedChatId(chatId);
    setIsNewChat(false);
  };

  const handleNewChat = (newChatId: string): void => {
    dispatch(setCanSelectDocuments(true));
    dispatch(setSelectedDocuments([]));

    setIsNewChat(true);
    setSelectedChatId(newChatId);
  };

  useEffect(() => {
    dispatch(setSelectedDocuments([]));
    dispatch(setCanSelectDocuments(true));
    setIsInstructionsOpen(true);
  }, []);

  const handleFirstMessage = (): void => {
    setIsNewChat(false);
    setRefreshChatList((prev) => prev + 1);
  };

  const handleClosePreview = (): void => {
    dispatch(setCurrentFile(undefined));
  };

  return (
    <>
      <div className={styles['ask-your-docs-view']}>
        <div className={styles['side-bar']}>
          <Sidebar
            onChatSelect={handleSelectChat}
            selectedChatId={selectedChatId}
            selectedModel={selectedModel}
            onModelChange={setSelectedModel}
            onNewChat={handleNewChat}
            refreshChatList={refreshChatList}
            onRefreshChatList={() => setRefreshChatList((prev) => prev + 1)}
          />
        </div>
        <div className={styles.divider}></div>
        <div className={styles.chat}>
          <ChatContainer
            chatId={selectedChatId}
            model={selectedModel}
            isNewChat={isNewChat}
            onFirstMessage={handleFirstMessage}
          />
        </div>
        {currentFile && (
          <>
            <div className={styles.divider}></div>
            <div className={styles['pdf-preview']}>
              <Button
                variant="icon"
                aria-label="Close Preview"
                className={styles.close}
                onClick={handleClosePreview}
              >
                <Button.Icon>
                  <CloseIcon />
                </Button.Icon>
              </Button>

              <PDFHighlightPreview
                highlightCoords={undefined}
                selectedHighlight={undefined}
                showHighlights={false}
              />
            </div>
          </>
        )}
      </div>

      <Button
        variant="primary"
        aria-label="Instructions"
        className={styles['instructions-btn']}
        onClick={() => setIsInstructionsOpen(true)}
      >
        ?
      </Button>

      <AskYourDocsInstructions
        isOpen={isInstructionsOpen}
        onClose={() => setIsInstructionsOpen(false)}
      />
    </>
  );
};
